function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2285 10.2739C16.1117 10.2739 15.198 10.9807 14.6904 11.8893C15.4011 12.596 15.9087 13.6057 15.9087 14.8172C15.9087 15.0191 15.9087 15.221 15.8072 15.423C16.2133 15.6249 16.6194 15.7258 17.127 15.7258C18.6498 15.7258 19.8681 14.5143 19.8681 12.9999C19.9696 11.4855 18.7513 10.2739 17.2285 10.2739Z",
  fill: "#62B5FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0967 17.2403C15.9089 17.4422 16.518 17.7451 17.1271 18.2499C17.7363 18.7547 18.0408 19.4614 18.2439 20.0672C19.6652 19.8653 20.985 19.2595 22.0002 18.3508V18.2499C22.0002 17.4422 21.6957 16.8364 21.0865 16.3316C20.5789 15.8268 20.0713 15.6249 19.3606 15.5239C19.1576 15.5239 18.9545 15.5239 18.853 15.6249C17.8378 16.1297 16.8226 16.1297 15.8073 15.7258C15.7058 16.3316 15.4012 16.8364 15.0967 17.2403Z",
  fill: "#62B5FF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.8881 15.322C7.8881 15.1201 7.78658 14.9182 7.8881 14.7162C7.8881 13.6057 8.29419 12.596 9.10638 11.8893C8.70028 10.9807 7.78658 10.2739 6.66983 10.2739C5.14698 10.2739 3.92871 11.4855 3.92871 12.9999C3.92871 14.5143 5.14698 15.7258 6.66983 15.7258C7.07592 15.6249 7.58354 15.5239 7.8881 15.322Z",
  fill: "#62B5FF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.77157 18.25C7.27919 17.7452 7.98985 17.3413 8.80203 17.2404C8.49746 16.8365 8.1929 16.3317 8.09137 15.8269C7.07614 16.2308 6.06091 16.2308 5.04569 15.726C4.84264 15.625 4.63959 15.625 4.53807 15.625C3.92893 15.726 3.3198 15.9279 2.91371 16.4327C2.40609 16.9375 2.10152 17.6442 2 18.351V18.4519C3.01523 19.3606 4.33502 19.9663 5.75634 20.1683C5.85787 19.4615 6.26396 18.8558 6.77157 18.25Z",
  fill: "#62B5FF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9489 17.9471C13.7763 17.9471 15.1977 16.5337 15.1977 14.7164C15.1977 12.8991 13.7763 11.4856 11.9489 11.4856C10.1215 11.4856 8.7002 12.8991 8.7002 14.7164C8.7002 16.5337 10.1215 17.9471 11.9489 17.9471Z",
  fill: "#178FFA"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5327 21.1778C17.5327 20.2691 17.1267 19.4614 16.5175 18.8557C15.9084 18.3509 15.2992 18.048 14.4871 17.947C14.284 17.947 14.081 17.947 13.8779 18.048C12.5581 18.6538 11.3399 18.6538 10.0201 18.048C9.81701 17.947 9.61397 17.947 9.41092 17.947C8.70026 18.048 7.9896 18.3509 7.38046 18.8557C6.77133 19.4614 6.36523 20.2691 6.36523 21.1778C6.36523 21.2788 6.36523 21.2788 6.36523 21.3797C7.88808 22.6922 9.81701 23.4999 11.949 23.4999C14.081 23.4999 16.1114 22.6922 17.5327 21.3797C17.5327 21.2788 17.5327 21.2788 17.5327 21.1778Z",
  fill: "#178FFA"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3636 11.4032L14.4545 11.5C14.6364 11.2097 14.8182 10.9194 15 10.629C15.5455 10.0484 16.3636 9.66129 17.0909 9.66129C17.3636 9.66129 17.6364 9.75806 17.9091 9.85484H19L16 5.5L13 9.85484H14.2727V11.4032H14.3636Z",
  fill: "#83EBB4"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M5.98837 9.57865C6.09302 9.57865 6.19767 9.57865 6.30232 9.57865C7.66279 9.57865 8.81395 10.3876 9.44186 11.5C9.96511 11.0955 10.593 10.8933 11.2209 10.7921V7.5H13L8.5 1.5L4 7.5H4.88953H5.77907V9.57865H5.98837Z",
  fill: "#18CC6C"
});

var SvgFansStatsPlayers = function SvgFansStatsPlayers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFansStatsPlayers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fansStatsPlayers.35afc2c1.svg";
export { ForwardRef as ReactComponent };